export default {
  lateralhead: {
    name: "头部侧倾",
    key: "lateralhead",
    definition: "在直立过程中，头部向左或右倾斜的现象。",
    harm: {
      bone: "颈椎侧屈",
      muscle:
        "屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长",
      neurovascular: "单侧椎动脉受压迫、单侧颈神经受压迫",
      des: "长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。",
    },
    risks: [
      {
        name: "肌肉韧带慢性劳损",
        des: "长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。",
      },
      {
        name: "颈椎病",
        des: "由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。",
      },
    ],
  },
  forwardhead: {
    name: "头部前倾",
    key: "forwardhead",
    definition: "头部过度向前伸的现象。",
    harm: {
      bone: "椎弓变直或出现反弓",
      muscle: "胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张",
      neurovascular:
        "胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足",
      des: "头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。",
    },
    risks: [
      {
        name: "头晕头痛",
        des: "头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。",
      },
      {
        name: "颈椎病",
        des: "长期的重度头部前倾可能会导致颈椎病。",
      },
    ],
  },
  unevenshoulder: {
    name: "高低肩",
    key: "unevenshoulder",
    definition: "肩峰左右高度差超过2CM则为高低肩。",
    harm: {
      bone: "脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷",
      muscle:
        "高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：",
      neurovascular: "",
      des: "肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。",
    },
    risks: [
      {
        name: "慢性头痛",
        des: "长期的高低肩容易产生颈肩部位、头部的慢性疼痛。",
      },
      {
        name: "骨刺",
        des: "高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。",
      },
      {
        name: "腰痛",
        des: "高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。",
      },
      {
        name: "长短腿",
        des: "由于高低肩造成的骨盆移位可能会使腿长发生变化。",
      },
    ],
  },
  roundedshoulder: {
    name: "圆肩",
    key: "roundedshoulder",

    definition: "由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。",
    harm: {
      bone: "肩胛骨外展、胸廓变小",
      muscle: "胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长",
      neurovascular: "",
      des: "圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。",
    },
    risks: [
      {
        name: "心脏负担加重",
        des: "过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。",
      },
      {
        name: "头痛",
        des: "肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。",
      },
      {
        name: "手臂麻木",
        des: "肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。",
      },
    ],
  },
  scoliosis: {
    name: "脊柱异位",
    key: "scoliosis",
    definition: "是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。",
    harm: {
      bone: "脊柱出现S型弯曲或C型弯曲",
      muscle: "凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛",
      neurovascular: "",
      des: "脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.",
    },
    risks: [
      {
        name: "脊柱侧弯",
        des: "平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。",
      },
      {
        name: "高低肩",
        des: "脊柱侧弯可能伴随高低肩症状。",
      },
      {
        name: "骨盆侧倾",
        des: "脊柱侧弯可能伴随骨盆侧倾症状。",
      },
    ],
  },
  unevenhip: {
    name: "骨盆侧倾",
    key: "unevenhip",
    definition: "在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。",
    harm: {
      bone: "骨盆倾斜",
      muscle:
        "高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力",
      neurovascular: "",
      des: "骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。",
    },
    risks: [
      {
        name: "慢性疼痛",
        des: "骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。",
      },
      {
        name: "腰椎间盘突出",
        des: "骨盆侧倾可能加重腰椎间盘突出风险。",
      },
      {
        name: "长短腿",
        des: "骨盆侧倾可能加重长短腿风险。。",
      },
    ],
  },

  oleg: {
    name: "O型腿",
    key: "oleg",
    definition: "是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。",
    harm: {
      bone: "O型腿（膝内翻）",
      muscle: "髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大",
      neurovascular: "",
      des: "下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。",
    },
    risks: [
      {
        name: "半月板损伤",
        des: "O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。",
      },
      {
        name: "关节炎",
        des: "严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n" + "置换手术。",
      },
    ],
  },

  xleg: {
    name: "X型腿",
    key: "xleg",

    definition: "指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。",
    harm: {
      bone: "X型腿（膝外翻）",
      muscle: "髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张",
      neurovascular: "",
      des: "影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。",
    },
    risks: [
      {
        name: "半月板损伤",
        des: "X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。",
      },
      {
        name: "关节炎",
        des: "严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n" + "置换手术。",
      },
    ],
  },
  kneehyperextension: {
    name: "膝过伸",
    key: "kneehyperextension",

    definition:
      "在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。",
    harm: {
      bone: "踝关节背屈不足，使膝关节无法向前移动",
      muscle: "臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛",
      neurovascular: "",
      des: "膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。",
    },
    risks: [
      {
        name: "膝关节退变",
        des: "长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。",
      },
      {
        name: "损害全身平衡",
        des: "膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。",
      },
    ],
  },
  xoleg: {
    name: "XO型腿",
    key: "xoleg",
    definition: "股骨、胫骨均呈内旋位，双侧小腿不能并拢。",
    harm: {
      bone: "这个是XO型腿",
      muscle: "这个是XO型腿",
      neurovascular: "",
      des: "XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。",
    },
    risks: [
      {
        name: "膝关节疼痛",
        des: "由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。",
      },
      {
        name: "膝关节炎",
        des: "重度XO型腿最终可能发展为膝关节骨性关节炎。",
      },
    ],
  },
};
